// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1uNaI","colMin":"styles_colMin__3Ww7q","colCheckbox":"styles_colCheckbox__1ockF"};